import { MutationTree } from 'vuex';
import { ECreateEditorMutation } from './create-editor.constants';
import { ICreateEditorState } from './create-editor.types';

export const mutations: MutationTree<ICreateEditorState> = {
  [ECreateEditorMutation.SetCreatedEditorId](state: ICreateEditorState, id: string) {
    state.createdEditorId = id;
  },
  [ECreateEditorMutation.SetState](state: ICreateEditorState, newState: ICreateEditorState) {
    state.createdEditorId = newState.createdEditorId;
  },
};
